// show: meta.label -> name
// name: component name
// meta.label: display label

// lazy loading Components
// https://github.com/vuejs/vue-router/blob/dev/examples/lazy-loading/app.js#L8
const lazyLoading = (name, index = false) => () => import(`views/${name}${index ? '/Index' : ''}.vue`)

export default [
  {
    path: '/dashboard',
    name: 'Dashboard',
    meta: {
      label: 'Dashboard',
      icon: 'fa-tachometer',
      requiresAuth: true,
      all: true
    },
    component: lazyLoading('dashboard', true)
  },
  // {
  //   meta: {
  //     label: 'Bookings',
  //     icon: 'fa-bed',
  //     expanded: false,
  //     admin: true,
  //     operator: true,
  //     master: true,
  //     client: true
  //   },
  //   children: [
  //     {
  //       label: 'New',
  //       path: '/services/general',
  //       component: lazyLoading('booking', true),
  //       meta: {
  //         requiresAuth: true,
  //         admin: true,
  //         operator: true,
  //         master: true,
  //         client: false
  //       }
  //     }
  //   ]
  // },
  {
    meta: {
      label: 'Services',
      icon: 'fa-desktop',
      expanded: false,
      admin: true,
      operator: true,
      master: true,
      client: true
    },
    children: [
      {
        label: 'Queue',
        path: '/services/queue',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          id: 'service-queue',
          view: 'queue',
          admin: true,
          operator: false,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Pending',
        path: '/services/pending',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          id: 'service-pending',
          view: 'pending',
          admin: true,
          operator: true,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Confirmed',
        path: '/services/confirmed',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          view: 'confirmed',
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Skipped',
        path: '/services/skipped',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          view: 'skipped',
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'List',
        path: '/services/general',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          view: 'general',
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Services',
        path: '/services/client',
        component: lazyLoading('services', true),
        meta: {
          requiresAuth: true,
          view: 'client',
          admin: false,
          operator: false,
          master: false,
          client: true
        }
      },
      {
        label: 'Missing Bookings',
        path: '/services/bookings_missing',
        component: lazyLoading('bookings_missing', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      }
    ]
  },
  {
    meta: {
      label: 'Tickets',
      icon: 'fa-exclamation-triangle',
      expanded: false,
      admin: true,
      operator: true,
      master: true,
      client: true
    },
    children: [
      {
        label: 'Queue',
        path: '/occurrences/queue',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-queue',
          view: 'queue',
          admin: true,
          operator: false,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Pending',
        path: '/occurrences/pending',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-pending',
          view: 'pending',
          admin: true,
          operator: true,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Queue Internal',
        path: '/occurrences/internal/queue/',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-internal-queue',
          view: 'internal.queue',
          admin: true,
          operator: false,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Pending Internal',
        path: '/occurrences/internal/pending',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-internal-pending',
          view: 'internal.pending',
          admin: true,
          operator: true,
          master: true,
          client: false,
          counter: true
        }
      },
      {
        label: 'Tickets',
        path: '/occurrences/client',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-client',
          view: 'client',
          admin: false,
          operator: false,
          master: false,
          client: true,
          counter: true
        }
      },
      {
        label: 'Generic',
        path: '/occurrences/generic',
        component: lazyLoading('occurrences/OccurrencesGeneric', false),
        meta: {
          requiresAuth: true,
          id: 'occurrence-generic',
          view: 'general',
          admin: true,
          operator: true,
          master: true,
          client: true,
          counter: true
        }
      },
      {
        label: 'List',
        path: '/occurrences/general',
        component: lazyLoading('occurrences', true),
        meta: {
          requiresAuth: true,
          id: 'occurrence-general',
          view: 'general',
          admin: true,
          operator: true,
          master: true,
          client: false,
          counter: false
        }
      }
    ]
  },
  {
    meta: {
      label: 'Customer',
      icon: 'fa-address-book',
      expanded: false,
      admin: true,
      operator: false,
      master: true,
      client: false
    },
    children: [
      {
        label: 'Agencies',
        path: '/agencies',
        component: lazyLoading('agencies', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false
        }
      },
      {
        label: 'Hotels',
        path: '/hotels',
        component: lazyLoading('hotels', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      // {
      //   label: 'Bases',
      //   path: '/bases',
      //   component: lazyLoading('bases', true),
      //   meta: {
      //     requiresAuth: true,
      //     admin: true,
      //     operator: true,
      //     master: true,
      //     client: false
      //   }
      // },
      {
        label: 'Users',
        path: '/clients',
        component: lazyLoading('clients', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Providers',
        path: '/customer/providers',
        component: lazyLoading('customer/Providers', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Hotelier',
        path: '/customer/chains',
        component: lazyLoading('customer/Chains', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Chains Hotel',
        path: '/customer/chains_hotel',
        component: lazyLoading('customer/ChainsHotel', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Platform',
        path: '/customer/platforms',
        component: lazyLoading('customer/Platforms', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      }
    ]
  },
  {
    meta: {
      label: 'Finances',
      icon: 'fa-usd',
      expanded: false,
      admin: true,
      operator: true,
      master: true,
      client: true
    },
    children: [
      {
        label: 'Accounts',
        path: '/finances/accounts',
        component: lazyLoading('finances/Accounts', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Sales',
        path: '/finances/sales',
        component: lazyLoading('finances/Sales', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Exchange',
        path: '/finances/exchange',
        component: lazyLoading('finances/Exchange', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Invoice Generation',
        path: '/finances/services/invoice',
        component: lazyLoading('finances/ServicesInvoice', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Invoices',
        path: '/finances/invoices',
        component: lazyLoading('finances/Invoices', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Invoices V2',
        path: '/finances/V2/invoices',
        component: lazyLoading('finances/V2/Invoices', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Payments V2',
        path: '/finances/V2/payments',
        component: lazyLoading('finances/V2/Payments', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Refunds V2',
        path: '/finances/V2/refunds',
        component: lazyLoading('finances/V2/Refunds', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Refunds Payment',
        path: '/finances/V2/refunds_payment',
        component: lazyLoading('finances/V2/RefundsPayment', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Card Payments',
        path: '/finances/card_payments',
        component: lazyLoading('finances/CardServices', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Invoices',
        path: '/client/invoices',
        component: lazyLoading('client/Invoice', false),
        meta: {
          requiresAuth: true,
          admin: false,
          operator: false,
          master: false,
          client: true
        }
      },
      // {
      //   label: 'Invoice Upload',
      //   path: '/finances/invoices/upload',
      //   component: lazyLoading('finances/Invoices/upload', false),
      //   meta: {
      //     requiresAuth: true,
      //     admin: true,
      //     operator: true,
      //     master: true,
      //     client: false
      //   }
      // },
      // {
      //   label: 'Conciliation',
      //   path: '/finances/invoices/conciliation',
      //   component: lazyLoading('finances/Invoices/conciliation', false),
      //   meta: {
      //     requiresAuth: true,
      //     admin: true,
      //     operator: true,
      //     master: true,
      //     client: false
      //   }
      // },
      {
        label: 'Payments Generation',
        path: '/finances/services/payment',
        component: lazyLoading('finances/ServicesPayment', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Payments Order',
        path: '/finances/payments',
        component: lazyLoading('finances/Payments', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Debits / Credits',
        path: '/finances/debit_credit',
        component: lazyLoading('finances/DebitsCredits', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Debits / Credits Skip',
        path: '/finances/debit_credit_skip',
        component: lazyLoading('finances/DebitsCreditsSkip', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Refunds',
        path: '/finances/refunds',
        component: lazyLoading('finances/Refunds', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Finances',
        path: '/finances/finances',
        component: lazyLoading('finances/Finances', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'NFS-e',
        path: '/finances/nfse',
        component: lazyLoading('nfse', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Invoices/P.O - Rules',
        path: '/finances/invoice_payment_rules',
        component: lazyLoading('finances/InvoicePaymentRules', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      },
      {
        label: 'Cards',
        path: '/finances/cards',
        component: lazyLoading('finances/Cards', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: true,
          master: true,
          client: false
        }
      }
    ]
  },
  {
    meta: {
      label: 'Business Inteligence',
      icon: 'fa-globe',
      expanded: false,
      admin: true,
      operator: true,
      master: true,
      client: false
    },
    children: [
      {
        label: 'Save Money',
        path: '/bi/save',
        component: lazyLoading('bi/Save', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      },
      {
        label: 'Changes',
        path: '/bi/changes',
        component: lazyLoading('bi/Changes', false),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false,
          departament: 2
        }
      }
      // {
      //   label: 'Searches',
      //   path: '/bi/searches',
      //   component: lazyLoading('bi/searches', false),
      //   meta: {
      //     requiresAuth: true,
      //     admin: true,
      //     operator: true,
      //     master: true,
      //     client: false,
      //     departament: 2
      //   }
      // }
    ]
  },
  {
    meta: {
      label: 'System',
      icon: 'fa-gear',
      expanded: false,
      admin: true,
      operator: false,
      master: true,
      client: false
    },
    children: [
      {
        label: 'Users',
        path: '/users',
        component: lazyLoading('users', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: false
        }
      },
      {
        label: 'Trending',
        path: '/trending',
        component: lazyLoading('trending', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: false,
          client: false,
          departament: 3
        }
      }
    ]
  },
  {
    meta: {
      label: 'System',
      icon: 'fa-gear',
      expanded: false,
      admin: false,
      operator: false,
      master: false,
      client: true
    },
    children: [
      {
        label: 'Users',
        path: '/clients',
        component: lazyLoading('clients', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: true
        }
      },
      {
        label: 'Logs',
        path: '/logs',
        component: lazyLoading('logs', true),
        meta: {
          requiresAuth: true,
          admin: true,
          operator: false,
          master: true,
          client: true
        }
      }
    ]
  },
  {
    label: 'Book Ezconnect',
    icon: 'fa-bed',
    path: '/users',
    component: lazyLoading('users', true),
    meta: {
      icon: 'fa-bed',
      redirect: true,
      requiresAuth: true,
      admin: false,
      operator: false,
      master: false,
      client: true
    }
  }
]



// WEBPACK FOOTER //
// ./client/router/menu.js